export default "__VITE_ASSET__CyBbsE0y__"